<app-progress-bar></app-progress-bar>
<app-top-nav></app-top-nav>
<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>
<p-toast position="bottom-right" [key]="progressToastKey">
  <ng-template #message let-message>
    <span class="p-toast-message-icon pi pi-info-circle"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail">{{ toastyService.progressToastDetails()[message.data] }}</div>
    </div>
  </ng-template>
</p-toast>
